export default "/public/dist/img/Cosefoto_1.jpg";